package com.devi3east.bashbuddy.features.common.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import bashbuddy.composeapp.generated.resources.Res
import bashbuddy.composeapp.generated.resources.bash_buddy_logo
import org.jetbrains.compose.resources.painterResource

@Composable
fun BashBuddyLoadingScreen() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.White),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Image(
                painter = painterResource(
                    Res.drawable.bash_buddy_logo
                ),
                contentDescription = "bash buddy",
                modifier = Modifier.width(240.dp),
                contentScale = ContentScale.Fit
            )

            Spacer(
                modifier = Modifier.height(24.dp)
            )

            CircularProgressIndicator(
                color = MaterialTheme.colorScheme.primary
            )
        }
    }
}